import React from 'react'
import ReactDOMServer from 'react-dom/server';
import moment from 'moment'
import '../../../assets/css/a4.css';
import {inWords, removeZeros} from '../../../utils/misc'
import {getUserSettings, getUserProfile} from '../../../storage'
import {InvoiceSerialGenerator} from '../utils'
import {HeaderStyle2} from './partials'

import HistoryChoser from '../historyChoser'

class InvoiceA4 extends React.Component {

  render() {

    let company = this.props.company
    let invoice = this.props.invoice
    let historyRecords = this.props.history

    let historySelection
    let settings = this.props.settings ||  getUserSettings()


    let is_composition = false

    let invoice_date = moment(invoice.date).format('D-MM-YYYY')
    let billto
    let shipping_address
    let optionalRow = false
    let client_notes

    let table_cols

    if(company.tax_type === "C") {
      is_composition = true
    }

    if(is_composition) {
      table_cols = 9
    }
    else if(invoice.is_igst) {
      table_cols = 11
    }
    else {
      table_cols = 13
    }
    let show_mrp_column = false
    let show_unit_rate_with_tax_col = false
    let unit_rate_with_tax_header_label = "Price"
    let sezEndorsement
    let is_without_tax = false
    let show_container_unit = false
    let show_invoice_uom_column = true
    let options = settings.options
    let show_purchase_order_no = false
    let customers_sign_label = "Customer's Signature"
    let purchase_order
    let header_style = "1"

    if(typeof settings !== "undefined" && settings !== null) {
       if(settings.show_invoice_mrp_column) {
         show_mrp_column = true
         table_cols = table_cols+1
       }
       if(settings.show_invoice_container_info) {
         show_container_unit = true
       }

       if(!settings.show_invoice_uom_column) {
         show_invoice_uom_column = false
         table_cols = table_cols-1
       }

       if(settings.add_client_notes_to_invoice) {

         if(invoice.client) {
           client_notes = invoice.client.notes
           if(invoice.client.is_sez) {

             sezEndorsement = <small>Supply meant for SEZ Unit | </small>
             if(invoice.additional_params){
               invoice.additional_params.forEach((p)=>{
                 if(p.key === "sez_without_tax") {
                   is_without_tax = true
                   sezEndorsement = <small>Supply ment for SEZ Unit without Payment of IGST | </small>
                 }
               })
             }
           }
         }
       }
       if(options && options.enable_invoice_purchase_order) {
         show_purchase_order_no= true
         purchase_order = <div>Purchase Order: {invoice.purchase_order_no}</div>
       }

       if(options && options.default_invoice_header_style_option == "2") {
         header_style = "2"
       }

       if(options && options.show_invoice_history) {
         historySelection = <HistoryChoser handleHistorySelect={this.props.handleHistorySelect} records ={historyRecords} />
       }

       if(options && options.show_invoice_unit_rate_with_tax_col) {
         show_unit_rate_with_tax_col = true
         unit_rate_with_tax_header_label = options.invoice_unit_rate_with_tax_col_header
         table_cols = table_cols+1
       }

       if(options && options.invoice_customer_sign_label) {
         customers_sign_label = options.invoice_customer_sign_label
       }



    }

    if(invoice.add_cess) {
      table_cols = table_cols + 3
    }
    if(invoice.add_tcs){
      table_cols = table_cols + 1
    }


    let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>


    let transportSection

    let transportlabel = invoice.transportlabel
    if(typeof transportlabel !== "undefined" && transportlabel !== null) {

      let t_label_name, t_bill_no, t_lr_no, t_challan_no, t_vehicle_no, t_ship_by, t_transporter_name, t_transporter_id, t_transporter_gstin
      t_bill_no = transportlabel.bill_no
      t_label_name = transportlabel.label_name
      if(t_label_name === "way_bill_no") {
        t_label_name = <strong>Way Bill No: </strong>
      }
      else if(t_label_name === "e_sugam_no"){
        t_label_name = <strong>E Sugam No: </strong>
      }
      else if (t_label_name === "eway_bill_no") {
        t_label_name = <strong>EWay Bill No: </strong>
      }
      t_vehicle_no = transportlabel.vehicle_no
      if(typeof t_vehicle_no !== "undefined" && t_vehicle_no !== null && t_vehicle_no.length > 0) {
        t_vehicle_no = <span><strong>Vehicle No: </strong> {t_vehicle_no}</span>
      }
      t_challan_no = transportlabel.challan_no
      if(typeof t_challan_no !== "undefined" && t_challan_no !== null && t_challan_no.length > 0) {
        t_challan_no = <span><strong>Challan No: </strong> {t_challan_no}</span>
      }
      t_lr_no = transportlabel.lr_no
      if(typeof t_lr_no !== "undefined" && t_lr_no !== null && t_lr_no.length > 0 ) {
        t_lr_no = <span><strong>LR No: </strong> {t_lr_no}</span>
      }

      t_ship_by = transportlabel.ship_by
      if(typeof t_ship_by !== "undefined" && t_ship_by !== null && t_ship_by.length> 0) {
        t_ship_by = <span><strong>Ship By: </strong> {t_ship_by}</span>
      }
      t_transporter_name = transportlabel.transporter_name
      if(typeof t_transporter_name !== "undefined" && t_transporter_name !== null && t_transporter_name.length > 0) {
        t_transporter_name = <span><strong>Transporter Name: </strong> {t_transporter_name}</span>
      }
      t_transporter_id = transportlabel.transporter_id
      if(typeof t_transporter_id !== "undefined" && t_transporter_id !== null && t_transporter_id.length > 0) {
        t_transporter_id = <span><strong>Transporter ID: </strong> {t_transporter_id}</span>
      }
      t_transporter_gstin = transportlabel.transporter_gstin
      if(typeof t_transporter_gstin !== "undefined" && t_transporter_gstin !== null && t_transporter_gstin.length > 0) {
        t_transporter_gstin = <span><strong>Transporter GSTIN: </strong> {t_transporter_gstin}</span>
      }

      transportSection = <div>
          <ul className="list-inline">
            <li>{t_label_name} {t_bill_no}</li>
            <li>{t_vehicle_no}</li>
            <li>{t_lr_no}</li>
            <li>{t_challan_no}</li>
            <li>{t_ship_by}</li>
            <li>{t_transporter_name}</li>
            <li>{t_transporter_id}</li>
            <li>{t_transporter_gstin}</li>
          </ul>
      </div>
    }


    if(typeof invoice.client !== "undefined" && invoice.client !== null) {

      let client_gstin
      let client_phone
      if(typeof invoice.client.gstin !== "undefined" && invoice.client.gstin !== null && invoice.client.gstin.length > 0) {
        client_gstin = "GSTIN-"+invoice.client.gstin
      }
      if(typeof invoice.client.phone !== "undefined" && invoice.client.phone !== null && invoice.client.phone.length > 0) {
        client_phone = "Ph: " + invoice.client.phone
      }
      if(!invoice.client.same_as_biiling) {
        shipping_address = <div>  <div className="gray">
                <strong>{invoice.client.name}</strong>
          </div>
          <div className="gray">
              {invoice.client.shipping_address}
          </div>
          <div className="gray">
          <span className="gray">
          {invoice.client.shipping_city}
          </span>
          <span className="gray">
          {" "+invoice.client.shipping_state} {" "+invoice.client.shipping_pin}
          </span>
          <span className="gray">
          {invoice.client.shipping_state_code.length > 0 ? " State Code: "+invoice.client.shipping_state_code: ""}
          </span>

          </div>

          <div>
            {client_notes}
          </div>

        </div>
      }
      else {
        shipping_address = <div>  <div className="gray">
                <strong>{invoice.client.name}</strong>
          </div>
          <div className="gray">
              {invoice.client.address}
          </div>
          <div className="gray">
            <span className="gray">
            {invoice.client.city}
            </span>
            <span className="gray">
            {" "+invoice.client.state} {" "+invoice.client.pin}
            </span>
          <span className="gray">
          {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
          </span>

          </div>
          <div>
            {client_notes}
          </div>
          </div>
      }

      billto = <div className="row">
      <div className="col-xs-6">
        <div className="">
        <strong>Bill To</strong>
          <div className="gray">
              <strong>{invoice.client.name}</strong>
          </div>
          <div className="gray">
              {invoice.client.address}
          </div>
          <div>
            <span className="gray">
           {invoice.client.city} {" "+invoice.client.state}
            </span>
            <span className="gray">
            {" "+invoice.client.pin}
            </span>
            <span className="gray">
            {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
            </span>
          </div>
          <div>
          </div>
          <div className="gray">
             {client_gstin}
          </div>
        </div>
      </div>

      <div className="col-xs-6">
        <div className="">
        <strong>Ship To</strong>
          {shipping_address}
        </div>
        <div>
          {client_phone}
        </div>
      </div>
      <div className="col-xs-12">
      {transportSection}
      </div>
      </div>
    }
    else if(typeof invoice.department !== "undefined" && invoice.department !== null) {
      billto = <div style={{marginBottom:20}}>
            <div>Bill TO</div>
          <strong style={{fontSize:18}}>{invoice.department.name}</strong>
      </div>
    }

    let items, summaryRow

    if(invoice.saleitem_set.length > 0) {

      invoice.saleitem_set.sort((a,b)=>{
        return a.tableIndex - b.tableIndex
      })

      items = invoice.saleitem_set.map((saleitem, index)=>{
        let discountCol, cgstcol, sgstcol, igstcol, cessCol, tcsCol
        if(saleitem.discount_value > 0) {
            discountCol = <td className="text-right">{removeZeros(saleitem.discount_value)}</td>
        }
        else {
          discountCol = <td className="text-right"></td>
        }

        if(is_composition) {
              // Do nothing
        }
        else if(invoice.is_igst) {
          if(saleitem.igst_amount > 0) {
            igstcol = <td colSpan={"2"} className="text-right">
              {parseFloat(saleitem.igst_amount).toFixed(2)} ({Number(saleitem.gst.igst)}%)

                 </td>
          }
          else {
            igstcol = <td colSpan={"2"} className="text-right">{parseFloat(saleitem.igst_amount).toFixed(2)}</td>
          }

        }
        else {

          if(saleitem.cgst_amount > 0) {
            cgstcol=  <td colSpan={"2"} className="text-right">
            {parseFloat(saleitem.cgst_amount).toFixed(2)} ({Number(saleitem.gst.cgst)}%)
               </td>
          }
          else {
            cgstcol= <td colSpan={"2"} className="text-right"></td>
          }

          if(saleitem.sgst_amount > 0) {
            sgstcol= <td colSpan={"2"} className="text-right">
                      {parseFloat(saleitem.sgst_amount).toFixed(2)} ({Number(saleitem.gst.sgst)}%)
                 </td>
          }
          else {
            sgstcol = <td colSpan={"2"} className="text-right"></td>
          }
        }

        if(invoice.add_cess) {
           cessCol = <td colSpan={"3"} className="text-right">
             {parseFloat(saleitem.cess_amount).toFixed(2)} ({Number(saleitem.cess_percentage)}%)
              + {parseFloat(saleitem.specific_cess_amount)}

           </td>
        }

        if(invoice.add_tcs){
          tcsCol = <td className="text-right">{Number(saleitem.tcs_value)} ({Number(saleitem.tcs_pct)}%)</td>
        }


        let item_unit, container_info
        if(typeof saleitem.unit !== "undefined" && saleitem.unit !== null) {
          item_unit = saleitem.unit.primary_unit

          let container_unit = saleitem.unit.container_unit, container_unit_plural = saleitem.unit.container_unit_plural
          if(typeof container_unit !== "undefined" && container_unit !== null && container_unit.length > 0) {
            let container_volume = saleitem.unit.container_volume

            let containers = Math.trunc(saleitem.quantity/container_volume)
            if(containers > 1 && typeof container_unit_plural !== "undefined" && container_unit_plural !== null && container_unit_plural.length > 0) {
              container_unit = container_unit_plural
            }
            let pieces =  saleitem.quantity%container_volume

            if(pieces > 0) {

              container_info = <div> <div>{item_unit}</div>  <div>{containers} {container_unit} & {pieces} {item_unit}</div></div>
            }
            else{
              container_info = <div> {item_unit} ({containers} {container_unit})</div>
            }
          }
          else {
            // In case if container doesn't exist
            container_info = item_unit
          }

        }
        let unit_info
        if(show_invoice_uom_column) {
          if(show_container_unit) {
            unit_info = <td>{container_info}</td>
          }
          else {
            unit_info = <td>{item_unit}</td>
          }
        }

        let unit_price, taxable_price, item_total = parseFloat(saleitem.total).toFixed(2)

        if(is_composition) {
            unit_price = Number(saleitem.selling_rate)
        }
        else {
           unit_price = Number(saleitem.selling_basic_rate)
           taxable_price = <td className="text-right">{parseFloat(saleitem.price).toFixed(2)}</td>
        }

        let mrp_column, unit_rate_with_tax_column
        if(show_mrp_column) {
          mrp_column = <td className="text-right">{parseFloat(saleitem.mrp).toFixed(2)}</td>
        }

        if(show_unit_rate_with_tax_col){
          unit_rate_with_tax_column = <td className="text-right">{Number(saleitem.selling_rate)}</td>
        }



        return <tr key={index}>
          <td>{saleitem.tableIndex}</td>
          <td><div>{saleitem.name}</div></td>
          <td><div>{saleitem.hsn}</div> </td>
          <td className="text-right">
            <div>{Number(saleitem.quantity)}</div>
          </td>
          {unit_info}
          <td className="text-right">{unit_price}</td>
          {unit_rate_with_tax_column}
          {mrp_column}
          {discountCol}
          {taxable_price}
          {cgstcol}{sgstcol}{igstcol}{cessCol}{tcsCol}
          <td className="text-right">{item_total}</td>
      </tr>
      })


      let summaryQuantity=0, summaryDiscount=0, summaryTaxable=0, summaryIGST=0, summaryCGST=0,
       summarySGST=0, summaryTotal=0, summaryCess = 0, summarySpecificCess = 0, summaryTCS=0
      let percentages={cgst:{}, sgst:{}, igst:{}, cess:{}, tcs:{}}
      for (var i = 0; i < invoice.saleitem_set.length; i++) {
          const si = invoice.saleitem_set[i]
          summaryQuantity = summaryQuantity + parseFloat(si.quantity)
          summaryDiscount = summaryDiscount + parseFloat(si.discount_value)
          summaryTaxable = summaryTaxable + parseFloat(si.price)
          summaryIGST = summaryIGST + parseFloat(si.igst_amount)
          summaryCGST = summaryCGST + parseFloat(si.cgst_amount)
          summarySGST = summarySGST + parseFloat(si.sgst_amount)
          summaryCess = summaryCess + parseFloat(si.cess_amount) + parseFloat(si.specific_cess_amount)
          summaryTCS = summaryTCS + (si.tcs_value ? parseFloat(si.tcs_value): 0)
          summarySpecificCess = summarySpecificCess + parseFloat(si.specific_cess_amount)
          summaryTotal = summaryTotal + parseFloat(si.total)


          const unique_cgst_pct = si.gst.cgst, unique_sgst_pct = si.gst.sgst, unique_igst_pct = si.gst.igst, unique_cess_pct = si.cess_percentage
          const igst_s_amount = parseFloat(si.igst_amount)
          const cgst_s_amount = parseFloat(si.cgst_amount)
          const sgst_s_amount = parseFloat(si.sgst_amount)
          const cess_s_amount = parseFloat(si.cess_amount)
          const specific_cess_amount = parseFloat(si.specific_cess_amount)
          const taxable_price = parseFloat(si.price)
          const tcs_value  = si.tcs_value ? parseFloat(si.tcs_value): 0
          const total = parseFloat(si.total)



          let tcs_percentages = percentages['tcs']
          if(typeof tcs_percentages[si.tcs_pct] !== "undefined") {
            let t = tcs_percentages[si.tcs_pct]
            t.total = t.total + tcs_value
          }
          else {
                tcs_percentages[si.tcs_pct] = {total:tcs_value}
                }
          percentages['tcs'] = tcs_percentages

          let cgst_percentages = percentages['cgst']

          if(typeof cgst_percentages[unique_cgst_pct] !== "undefined") {
            let s = cgst_percentages[unique_cgst_pct]

            s.cgst_amount= s.cgst_amount + cgst_s_amount
            s.sgst_amount= s.sgst_amount + sgst_s_amount
            // s.igst_amount= s.igst_amount + igst_s_amount
            s.taxable_price = s.taxable_price + taxable_price
            s.total = s.total + total

          }
          else {
            cgst_percentages[unique_cgst_pct] = {cgst_amount:cgst_s_amount,  sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
          }
          percentages['cgst'] = cgst_percentages

          let igst_percentages = percentages['igst']

          if(typeof igst_percentages[unique_igst_pct] !== "undefined") {
            let s = igst_percentages[unique_igst_pct]
            s.igst_amount= s.igst_amount + igst_s_amount
            s.taxable_price = s.taxable_price + taxable_price
            s.total = s.total + total
          }
          else {
            igst_percentages[unique_igst_pct] = {igst_amount:igst_s_amount, taxable_price: taxable_price, total: total}
          }

          percentages['igst'] = igst_percentages


          let cess_percentages = percentages['cess']
          if(typeof cess_percentages[unique_cess_pct] !== "undefined") {
             let s = cess_percentages[unique_cess_pct]
             s.cess_amount = s.cess_amount + cess_s_amount

             s.taxable_price = s.taxable_price + taxable_price
             s.total = s.total + total

          }
          else {
            cess_percentages[unique_cess_pct] = {cess_amount:cess_s_amount,
              specific_cess_amount:specific_cess_amount, taxable_price:taxable_price, total:total}
          }

          percentages['cess'] = cess_percentages

      }

      if(invoice.additional_charges) {
        invoice.additional_charges.forEach((charge,id)=>{

          if(charge.value) {
            summaryTaxable = summaryTaxable + parseFloat(charge.value)
            summaryTotal = summaryTotal + parseFloat(charge.total)
            if(charge.tax_igst_value) {
              summaryIGST = summaryIGST + parseFloat(charge.tax_igst_value)
              summaryCGST = summaryCGST + parseFloat(charge.tax_cgst_value)
              summarySGST = summarySGST + parseFloat(charge.tax_cgst_value)
            }
          }


        })
      }

      summaryDiscount = removeZeros(parseFloat(summaryDiscount).toFixed(2))
      summaryTaxable = parseFloat(summaryTaxable).toFixed(2)
      summaryIGST = parseFloat(summaryIGST).toFixed(2)
      summaryCGST = parseFloat(summaryCGST).toFixed(2)
      summarySGST = parseFloat(summarySGST).toFixed(2)
      summaryCess = parseFloat(summaryCess).toFixed(2)
      summaryTCS = parseFloat(summaryTCS).toFixed(2)
      summaryTotal = parseFloat(summaryTotal).toFixed(2)

      let wordsRow, roundOffRow, subTotalRow
      let roundOffValue= parseFloat(invoice.total) - parseFloat(summaryTotal)

      if(roundOffValue >= 0) {
          roundOffValue = "+" + parseFloat(roundOffValue).toFixed(2)
      }
      else {
          roundOffValue = parseFloat(roundOffValue).toFixed(2)
      }
      let mrp_cell, uom_cell, unit_rate_with_tax_cell
      if(show_mrp_column) {
        mrp_cell = <td></td>
      }
      if(show_invoice_uom_column) {
        uom_cell =<td></td>
      }
      if(show_unit_rate_with_tax_col) {
        unit_rate_with_tax_cell = <td></td>
      }


      let additional_charges = invoice.additional_charges



      if(is_composition) {
         let cess
        subTotalRow = <tr key={"sub_total_row"} className="text-right"><td colSpan={table_cols-2}>Sub Total</td><td>{summaryTotal}</td></tr>

        wordsRow=<tr  key={"words_row_1"}><td className="text-right" colSpan={3}>
        <div className="space-large-bottom">Total Amount In Words</div></td><td className="text-right" colSpan={table_cols-4} >{inWords(invoice.total)}</td></tr>

        roundOffRow = <tr className="text-right" rowSpan={2} key={"roundoff_row_1"}>
        <td colSpan={table_cols-2} > Round off </td>
        <td>{roundOffValue}</td>
        </tr>
        if(invoice.add_cess) {
          cess = <td className="text-right" colSpan={2}>{summaryCess}</td>
        }

        summaryRow = <tr key={"summary_row"}>
              <td colSpan={3} className="text-right">Total Summary</td><td className="text-right">{summaryQuantity}</td>
              {uom_cell}<td></td>{unit_rate_with_tax_cell}{mrp_cell}<td className="text-right">{summaryDiscount}</td> {cess}
              <td className="text-right">{invoice.total}</td>
        </tr>

      }
      else if(invoice.is_igst) {

        if(additional_charges) {
          additional_charges.forEach((charge,id)=>{
            let cols_offset = invoice.add_cess ? 7 : 4
            let cols_add
            if(invoice.add_cess) {
              cols_add = <td colSpan={3}></td>
            }
              if(charge.value) {
                const tx = charge.tax_pct ? "("+charge.tax_pct+"%)" : ""
              const ac =  <tr key={"additiona_charge"+id} className="text-right">
                       <td colSpan={table_cols-cols_offset}>{charge.key}</td>
                       <td>{charge.value}</td>

                       <td colSpan={2}>
                          {charge.tax_igst_value} {tx}
                       </td>
                       {cols_add}
                       <td>{parseFloat(charge.total).toFixed(2)}</td>
               </tr>

               items.push(ac)
              }
          })
        }

        let cess
        subTotalRow = <tr className="text-right" key={"sub_total_row"}><td colSpan={table_cols-1}>Sub Total</td><td>{summaryTotal}</td></tr>
        wordsRow=<tr  key={"words_row_1"}><td className="text-right" colSpan={3}>
        <div className="space-large-bottom">Total Amount In Words</div></td><td className="text-right" colSpan={table_cols-3} >{inWords(invoice.total)}</td></tr>

        roundOffRow = <tr className="text-right" rowSpan={2} key={"roundoff_row_1"}>
        <td colSpan={table_cols-1} > Round off </td>
        <td>{roundOffValue}</td>
        </tr>
        if(invoice.add_cess) {
          cess = <td className="text-right" colSpan={3}>{summaryCess}</td>
        }

        let tcs
        if(invoice.add_tcs) {
          tcs = <div className="row">

            <div className="col-xs-12 text-right">
               &#8377; {summaryTCS}
            </div>
            </div>
        }

        summaryRow = <tr key={"summary_row"}>
          <td colSpan={3} className="text-right">Total Summary</td><td className="text-right">{summaryQuantity}</td>
              {uom_cell}<td></td>{unit_rate_with_tax_cell}{mrp_cell}<td className="text-right">{summaryDiscount}</td>
              <td className="text-right">{summaryTaxable}</td>
              <td colSpan={"2"} className="text-right">{summaryIGST}</td> {cess}
              <td className="text-right">{invoice.total}</td>
        </tr>
      }
      else {
        let cess
        subTotalRow = <tr key={"sub_total_row"} className="text-right"><td colSpan={table_cols-1}>
        Sub Total
        </td><td>{summaryTotal}</td></tr>
        roundOffRow = <tr className="text-right" rowSpan={2} key={"roundoff_row_1"}>
            <td colSpan={table_cols-1} > Round off </td>
            <td>{roundOffValue}</td>
            </tr>

        wordsRow=<tr  key={"words_row_1"}><td className="text-right" colSpan={3}>
        <div className="space-large-bottom">Total Amount In Words</div></td><td className="text-right" colSpan={table_cols-3} >{inWords(invoice.total)}</td></tr>
        if(invoice.add_cess) {
            cess = <td className="text-right" colSpan={3}>{summaryCess}</td>
        }
        let tcs
        if(invoice.add_tcs) {
          tcs = <div className="row">
            
            <div className="col-xs-12 text-right">
               &#8377; {summaryTCS}
            </div>
            </div>
        }
        summaryRow = <tr key={"summary_row"}>
              <td colSpan={"3"} className="text-right">Total Summary</td>
              <td className="text-right">{summaryQuantity}</td>
              {uom_cell}<td></td>{unit_rate_with_tax_cell}{mrp_cell}<td className="text-right">{summaryDiscount}</td>
              <td className="text-right">{summaryTaxable}</td>
              <td colSpan={"2"} className="text-right">{summaryCGST}</td><td colSpan={"2"} className="text-right">{summarySGST}</td>
              {cess}{tcs}
              <td className="text-right"><span style={{fontSize:'130%'}}><strong>{invoice.total}</strong></span></td>
        </tr>

        if(additional_charges) {
          additional_charges.forEach((charge,id)=>{
              if(charge.value) {
                let cols_offset = invoice.add_cess ? 9 : 6
                let cols_add
                if(invoice.add_cess) {
                  cols_add = <td colSpan={3}></td>
                }

                const tx = charge.tax_pct ? "("+charge.tax_pct+"%)" : ""
              const ac =  <tr key={"additiona_charge"+id} className="text-right">
                       <td colSpan={table_cols-cols_offset}>{charge.key}</td>
                       <td>{charge.value}</td>
                       <td colSpan={2}>
                          {charge.tax_cgst_value}
                       </td>
                       <td colSpan={2}>
                         {charge.tax_cgst_value}
                       </td>
                       {cols_add}
                       <td>{parseFloat(charge.total).toFixed(2)}</td>
               </tr>

               items.push(ac)
              }
          })
        }

      }
      items.push(subTotalRow)
      items.push(roundOffRow)
      items.push(summaryRow)
      items.push(wordsRow)


      let taxRowHeaderBase, taxRowHeader,taxSummary

      if(typeof settings !== "undefined" && settings !== null) {

        if(settings.show_invoice_tax_analysis && !is_without_tax) {

          if(is_composition) {
            // Do Nothing
          }
          else if(invoice.is_igst) {
            taxRowHeaderBase = <tr className="text-right" key={"tax_row_header_base"}>
              <td colSpan={table_cols-4} rowSpan={2}></td>
                  <td rowSpan={2}>Taxable Price</td><td className="text-center" colSpan={2}>IGST</td><td rowSpan={2}>Total Tax</td></tr>
            items.push(taxRowHeaderBase)
            taxRowHeader = <tr key={"tax_row_header"}><td>%</td><td>Value</td></tr>
            items.push(taxRowHeader)

            const igstPercentages = percentages['igst']


            let percentageKeys  = Object.keys(igstPercentages)
            let igst_tax_total = 0.0, tax_total=0.0
            if(percentageKeys.length > 0 ) {
              percentageKeys.sort((a,b)=>{
                   return a - b
                 })
                 for (var i=0; i<percentageKeys.length; i++) {
                   const pct_key = percentageKeys[i]
                   const s = igstPercentages[pct_key]
                   igst_tax_total = igst_tax_total + parseFloat(s.igst_amount)
                   tax_total = tax_total + parseFloat(s.igst_amount)
                   const igst_amount = parseFloat(s.igst_amount).toFixed(2)
                   const taxable_price = parseFloat(s.taxable_price).toFixed(2)
                   const total = parseFloat(s.igst_amount).toFixed(2)

                   const taxRow = <tr className="text-right" key={"tax_row_"+i}>
                   <td colSpan={table_cols-4}></td>
                   <td>{taxable_price}</td>
                   <td>{pct_key}</td>
                   <td>{igst_amount}</td>
                   <td>{total}</td></tr>
                   items.push(taxRow)
                 }
            }

            igst_tax_total = parseFloat(igst_tax_total).toFixed(2)
            tax_total = parseFloat(tax_total).toFixed(2)

            taxSummary = <tr key={"tax_footer_row"} className="text-right">
              <td colSpan={table_cols-4}>Tax Summary</td>
              <td>{summaryTaxable}</td>
              <td></td>
              <td>{igst_tax_total}</td>
              <td>{tax_total}</td>
            </tr>


          }
          else {

            let cess_tax_header
            taxRowHeader = <tr key={"tax_row_header"}><td>%</td><td>Value</td><td>%</td><td>Value</td></tr>
              taxRowHeaderBase = <tr className="text-right" key={"tax_row_header_base"}><td colSpan={table_cols-6} rowSpan={2}></td>
                    <td rowSpan={2}>Taxable Price</td><td className="text-center" colSpan={2}>CGST</td>
                    <td className="text-center" colSpan={2}>SGST</td><td rowSpan={2}>Total Tax</td></tr>
            if(invoice.add_cess) {
              cess_tax_header = <td rowSpan={2}></td>
              taxRowHeader = <tr key={"tax_row_header"}><td>%</td><td>Value</td><td>%</td><td>Value</td><td>%</td><td>Value</td><td className="text-center">+</td></tr>
                taxRowHeaderBase = <tr className="text-right" key={"tax_row_header_base"}>
                  <td colSpan={table_cols-9} rowSpan={2}></td>
                      <td rowSpan={2}>Taxable Price</td>
                      <td className="text-center" colSpan={2}>CGST</td>
                      <td className="text-center" colSpan={2}>SGST</td>
                      <td className="text-center" colSpan={3}>Cess</td>
                      <td rowSpan={2}>Total Tax</td></tr>
            }

            items.push(taxRowHeaderBase)

            items.push(taxRowHeader)

            const cgstPercentages = percentages['cgst']
            let cessPercentageKeys = Object.keys(percentages['cess'])
            if(cessPercentageKeys.length > 0) {
              cessPercentageKeys.sort((a,b)=>{
                   return a - b
                 })
            }
            let cgst_tax_total = 0.0, sgst_tax_total=0.0, tax_total=0.0, cess_tax_total = 0.0, specific_cess_total=0.0
            let percentageKeys  = Object.keys(cgstPercentages)
            if(percentageKeys.length > 0 ) {
              percentageKeys.sort((a,b)=>{
                   return a - b
                 })

                 for (var i=0; i<percentageKeys.length; i++) {
                   const pct_key = percentageKeys[i]
                   let td_cess

                   const s = cgstPercentages[pct_key]
                   cgst_tax_total = cgst_tax_total + parseFloat(s.cgst_amount)
                   sgst_tax_total = sgst_tax_total + parseFloat(s.sgst_amount)

                   const cgst_amount = parseFloat(s.cgst_amount).toFixed(2)
                   const sgst_amount = parseFloat(s.sgst_amount).toFixed(2)
                   const taxable_price = parseFloat(s.taxable_price).toFixed(2)
                   let total = parseFloat(s.cgst_amount + s.sgst_amount).toFixed(2)
                   let taxRow
                   if(invoice.add_cess) {
                     taxRow = <tr className="text-right" key={"tax_row_"+i}>
                    <td colSpan={table_cols-9}></td><td>{taxable_price}</td>
                    <td>{pct_key}</td><td>{cgst_amount}</td>
                    <td>{pct_key}</td><td>{sgst_amount}</td>
                    <td></td><td></td><td></td>
                    <td>{total}</td></tr>
                   }
                   else {
                     taxRow = <tr className="text-right" key={"tax_row_"+i}>
                    <td colSpan={table_cols-6}></td><td>{taxable_price}</td>
                    <td>{pct_key}</td><td>{cgst_amount}</td>
                    <td>{pct_key}</td><td>{sgst_amount}</td>
                    <td>{total}</td></tr>
                   }
                   tax_total = cgst_tax_total+sgst_tax_total

                   items.push(taxRow)
                 }


                 if(invoice.add_cess) {
                   let cessPercentages = percentages['cess']
                   for (var i=0; i<cessPercentageKeys.length; i++) {
                     const pct_key = cessPercentageKeys[i]
                     const s = cessPercentages[pct_key]
                     const cess_amout = parseFloat(s.cess_amount).toFixed(2)
                     const taxable_price = parseFloat(s.taxable_price).toFixed(2)
                     let total = parseFloat(s.cess_amount).toFixed(2)
                     let taxRow = <tr className="text-right" key={"cess_tax_row_"+i}>
                      <td colSpan={table_cols-9}></td><td>{taxable_price}</td>
                      <td></td><td></td>
                      <td></td><td></td>
                      <td>{pct_key}</td><td>{cess_amout}</td><td></td>
                      <td>{total}</td></tr>
                      cess_tax_total = cess_tax_total + parseFloat(s.cess_amount)

                     items.push(taxRow)
                   }
                   tax_total = tax_total + cess_tax_total + summarySpecificCess

                 }



            }

            cgst_tax_total = parseFloat(cgst_tax_total).toFixed(2)
            sgst_tax_total = parseFloat(sgst_tax_total).toFixed(2)
            cess_tax_total = parseFloat(cess_tax_total).toFixed(2)
            specific_cess_total = parseFloat(summarySpecificCess).toFixed(2)
            tax_total = parseFloat(tax_total).toFixed(2)

            taxSummary = <tr key={"tax_footer_row"} className="text-right">
              <td colSpan={table_cols-6}>Tax Summary</td>
              <td>{summaryTaxable}</td>

              <td ></td>
              <td>{cgst_tax_total}</td>
              <td ></td>
              <td>{sgst_tax_total}</td>
              <td>{tax_total}</td>
            </tr>

            if(invoice.add_cess) {
              taxSummary = <tr key={"tax_footer_row"} className="text-right">
                <td colSpan={table_cols-9}>Tax Summary</td>
                <td>{summaryTaxable}</td>

                <td ></td>
                <td>{cgst_tax_total}</td>
                <td ></td>
                <td>{sgst_tax_total}</td>
                <td ></td>
                <td>{cess_tax_total}</td>
                <td>{specific_cess_total}</td>

                <td>{tax_total}</td>
              </tr>
            }

          }
          items.push(taxSummary)
        }

      }
    }



    let discount
    if(invoice.totalDiscount > 0) {
      discount = <div className="row">
          <div className="col-xs-6">
            <strong>Discount  </strong>
          </div>
          <div className="col-xs-6 text-right">
             &#8377; {invoice.totalDiscount}
          </div>
      </div>
    }

    let totalBeforeDiscount = parseFloat(parseFloat(invoice.totalPrice) + parseFloat(invoice.totalDiscount)).toFixed(2)



    let cgst_header, sgst_header, igst_header, uom_header, mrp_header, unit_rate_with_tax_header, taxable_header, cess_header, tcs_header

    if(invoice.add_tcs){
    tcs_header= <th className="text-right">TCS</th>
    }

    if(is_composition) {
      // Do Nothing
    }
    else if(invoice.is_igst) {
      igst_header = <th colSpan={"2"} className="text-right">IGST</th>
      taxable_header = <th className="text-right">Taxable Price</th>
    }
    else {
      cgst_header = <th colSpan={"2"}  className="text-right">CGST</th>
      sgst_header = <th colSpan={"2"} className="text-right">SGST</th>
      taxable_header = <th className="text-right">Taxable Price</th>
    }

    if(invoice.add_cess) {
      cess_header = <th colSpan={"3"}  className="text-right">Cess</th>
    }

    let serial = invoice.serial, invoice_label = "INVOICE"
    let tnc, bankDetails, pan, declartion
    if(typeof settings !== "undefined" && settings !== null) {
        if(settings.invoice_label) {
          invoice_label = <span>{settings.invoice_label}</span>
        }
        if(settings.show_invoice_pan) {
          optionalRow= true
          pan = <div>Company Pan - {company.pan}</div>
        }
        if(settings.show_invoice_tnc) {
          optionalRow= true
          tnc = <div><u>Terms and Conditions</u>
              <div><p>{settings.invoice_tnc}</p></div>
      </div>
        }
        if(settings.show_invoice_declaration) {
          optionalRow= true
          declartion = <div><u>Declaration</u>
              <div><p>{settings.invoice_declaration}</p></div>
              </div>
        }

        if(settings.show_invoice_bankdetails) {
          optionalRow= true
          bankDetails = <div><div className="row">
              <div className="col-xs-6">Bank Name</div>
              <div className="col-xs-6">{company.bank_name}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Account No</div>
                <div className="col-xs-6">{company.account_no}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">IFSC</div>
                <div className="col-xs-6">{company.ifsc_code}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Branch </div>
                <div className="col-xs-6">{company.branch_name}</div>
              </div>

              </div>
        }


        // if(settings.invoice_serial_prefix.length > 0) {
        //   serial = settings.invoice_serial_prefix+serial
        // }




        serial = <InvoiceSerialGenerator options={options} series_name={invoice.series_name} series_counter={invoice.series_counter} />

        if(document) {
          const s = ReactDOMServer.renderToStaticMarkup(serial)
          document.title = s
        }

        if(settings.show_invoice_mrp_column) {
          mrp_header = <th className="text-right">MRP</th>
        }
        else {
          mrp_header = null
        }
        if(show_unit_rate_with_tax_col) {
          unit_rate_with_tax_header = <th className="text-right">{unit_rate_with_tax_header_label}</th>
        }

        if(show_invoice_uom_column) {
          uom_header = <th className="table-item">UOM</th>
        }

    }

    let itemsHeader = <thead>
      <tr className="active">
        <th>S.No</th>
        <th className="table-item">Item Name</th>
        <th className="table-item">HSN</th>
        <th className="text-right">Qty</th>
        {uom_header}
        <th className="text-right">Unit Price</th>
        {unit_rate_with_tax_header}
        {mrp_header}
        <th className="text-right">Discount</th>

        {taxable_header}
        {cgst_header}{sgst_header}{igst_header}{cess_header}{tcs_header}
        <th className="text-right">Total</th>
      </tr>
    </thead>

    let termsAndBankRow =  <tr key={"terms_row_1"}>
      <td colSpan={table_cols}>
      <div className="row">
        <div className="col-xs-6">
        {pan}
        {tnc}
        {declartion}
        </div>
        <div className="col-xs-6 text-right">
        {bankDetails}
        </div>
      </div>
      </td>
      </tr>

    if(optionalRow) {
        items.push(termsAndBankRow)
    }

    let signatureRow = <tr key={"signature_row"}>
    <td colSpan={table_cols}>
      <table className=" table-no-borders" style={{width:'100%'}}>
        <tbody>
          <tr>
            <td style={{verticalAlign:'bottom'}}>
              <div>{customers_sign_label}</div>
            </td>
            <td className="text-right" style={{verticalAlign:'bottom'}}>
              <div className="space-medium-bottom">For {company.company_name}</div>
              <div>Authorized Signature</div>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
    </tr>

    items.push(signatureRow)


    let company_gstin, company_state_code, additional_params

    if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
      company_gstin = <span className="gray">{"GSTIN-" +company.gstin}</span>
    }

    if(company.state_code) {
      company_state_code = <span className="gray"> State Code: {company.state_code}</span>
    }
    if(company.additional_params && company.additional_params.length) {
      let additional_params_list = company.additional_params.map(function(param, i) {
        return <li key={i}><span className="gray">{param.key} {param.value}</span></li>
      })
      additional_params= <ul className="list-inline" style={{marginBottom:0}}>{additional_params_list}</ul>
    }


    let invoice_additional_params
    if(typeof invoice.additional_params !== "undefined" && invoice.additional_params !== null) {
      let additional_params_list = invoice.additional_params.map(function(param, i) {
        if(param.key === "sez_without_tax") {
          return null
        }
        else {
            return <div key={i}><span className="gray">{param.key} {param.value}</span></div>
        }

      })
      invoice_additional_params= <div style={{marginBottom:0}}>{additional_params_list}</div>
    }

    let headSection
    if(header_style == "2") {
      headSection = <HeaderStyle2 {...this.props} />
    }
    else {
      headSection =   <div className="row">
          <div className="col-xs-6">
            <div className="company-name text-uppercase">
              {company.company_name}
            </div>
            <div className="">
            <div className="company-address gray">
              {company.address}
            </div>
            <div className="company-address gray">
              <span className="company-state gray">{company.city}</span>
              <span className="company-state gray">{" "+company.state}</span>
              <span className="company-pin gray">{" "+ company.pin}</span>
            </div>

            <div className="company-email gray">
              {company.email}
            </div>
            <div className="company-phone gray">
              {company.phone}
            </div>
            <div className="company-state gray">
             {company_gstin} {company_state_code}
            </div>
            <div className="company-state gray">
             {additional_params}
            </div>
            </div>

          </div>
          <div className="col-xs-6">
          <div className="invoice-name text-right">
            {invoice_label}
          </div>
            <div className="text-right invoice-name">{serial}</div>
            <div className="gray text-right">
            Date: {invoice_date}
            </div>
            <div className="gray text-right">
              {purchase_order}
            </div>
            <div className="text-right gray">
                {invoice_additional_params}
            </div>
          </div>


        </div>

    }



      return   <div style={{position:'relative'}}>
        <div className="hidden-print" style={{position:'absolute', left:0}}>
          {historySelection}
        </div>

        <div className="preview-a4" ref={(pdf)=>{this.pdf = pdf}} id="printablePreview">

           <div className="invoice-name text-right">{this.props.print_type}</div>
          {headSection}
            <hr/>

            {billto}

            <div className="row">
            <div className="col-xs-12">
            <table className="table table-bordered table-condensed">
            {itemsHeader}
              <tbody>
                {items}
              </tbody>

            </table>
            </div>
            </div>


            <div className="row space-small hidden">
            <div className="col-xs-6 col-xs-offset-6">

                <div className="row">
                    <div className="col-xs-6">
                      <strong>Amount  </strong>
                    </div>
                    <div className="col-xs-6 text-right">
                       &#8377; {totalBeforeDiscount}
                    </div>
                </div>

                {discount}

                <div className="row">
                    <div className="col-xs-6">
                      <strong>GST  </strong>
                    </div>
                    <div className="col-xs-6 text-right">
                       &#8377; {invoice.totalTax}
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-6">
                    <strong>Total  </strong>
                    </div>
                    <div className="col-xs-6 text-right">
                       &#8377; {invoice.total}
                    </div>
                </div>

            </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
              {sezEndorsement}
              {brandRow}
              </div>

            </div>
          </div>
      </div>

  }
}

export default InvoiceA4



// WEBPACK FOOTER //
// ./src/components/invoice/previews/invoicea4.js